import { FC } from 'react';

import clsx from 'clsx';

import { BreadcrumbsProps } from './types';

import styles from './styles.module.scss';

export const Breadcrumbs: FC<BreadcrumbsProps> = ({ crumbs }) => {
  if (!crumbs.length) return null;

  return (
    <div className={styles.breadcrumbs}>
      {crumbs.map(({ name }, index) => {
        return (
          <div
            key={name}
            className={clsx(styles.breadcrumbs__item, index === crumbs.length - 1 && styles.breadcrumbs__active)}
          >
            {name}
          </div>
        );
      })}
    </div>
  );
};
